export const BACKEND_URL = "https://dn-dell.herokuapp.com"
